var map = {
	"./partner-bni.jpg": "f6ca",
	"./partner-break.webp": "015b",
	"./partner-gwo.webp": "0564",
	"./partner-laendlekassa.webp": "4b4a",
	"./partner-provokateur.webp": "1631",
	"./partner-sonnweber.jpg": "fe33",
	"./partner-teamwork.webp": "fcba",
	"./partner-tourismus-montafon_rot.svg": "07c7",
	"./partner-tourismus-montafon_weiss.svg": "2097",
	"./partner-wagner-oscar.jpg": "63bb",
	"./portrait-sara-katze.webp": "319c",
	"./portrait-sara-lachend.webp": "59cc",
	"./portrait-sara-laptop.jpg": "b67a",
	"./portrait-sara-neutral.jpg": "9189"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86bf";